import React from 'react';
import { AwardIcon, BookOpenIcon, ClockIcon, CreditCardIcon, FileTextIcon, GiftIcon, LockIcon, ShieldCheckIcon, SparklesIcon, StarIcon, UsersIcon } from 'lucide-react';
import { mockupUrl } from '../data/content';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-170" data-mp="4mi5dgdtryh4">
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-171" data-mp="12a0ljc9tg2v5">
        <p className="mb-5 inline-flex rounded-full border border-gold/30 bg-gold/10 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-gold md:mb-7" data-id="element-172" data-mp="1274odq5sli7r">
          🤸‍♀️ Compra Digital Ya™
        </p>
        <h1 className="mx-auto max-w-4xl text-[1.9rem] font-black leading-[1.05] tracking-tight text-white md:text-6xl" data-id="element-173" data-mp="ncgm0kvouzwd">
          Todo tu año de Gimnasia Artística.
          <br data-id="element-174" data-mp="3d2tln1u126au" />
          <span className="text-gold" data-id="element-175" data-mp="3cz5vmcnsk20v">Listo. Desde hoy.</span>
        </h1>
        <a href="#pricing" className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Ver las opciones de compra del Combo Completo Gimnasia Artística 2026" data-id="element-176" data-mp="3814bdoempwnt">
          <img className="w-full max-w-[680px] object-contain drop-shadow-[0_30px_60px_rgba(245,199,75,.18)] transition-transform duration-200 ease-smooth group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Gimnasia Artística 2026 con sus 6 tomos, bonos y Academia 12 meses" data-id="element-177" data-mp="39acw2k2aneqw" />
        </a>
        <p className="mx-auto max-w-3xl text-base font-medium leading-relaxed text-zinc-300 md:text-xl" data-id="element-178" data-mp="35aatm8oqihak">
          <strong className="text-white" data-id="element-179" data-mp="2qlelkbmoh49y">COMBO COMPLETO GIMNASIA ARTÍSTICA 2026.</strong> El sistema
          N°1 para entrenadores de Gimnasia Artística en Argentina. Inicial → Avanzado, los 4
          aparatos, todo resuelto: ejercicios, progresiones, circuitos, clases y evaluaciones listos
          para usar.
        </p>
        <p className="mt-4 text-sm font-bold uppercase tracking-wide text-gold md:text-base" data-id="element-180" data-mp="2lml8ulf7thau">
          Sin buscar. Sin armar. Sin perder domingos.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-medium text-zinc-400 md:text-sm" data-id="element-181" data-mp="naji3pzjuhg2">
          <span className="flex items-center gap-1.5" data-id="element-182" data-mp="ia5i8v83qdt4">
            <FileTextIcon aria-hidden="true" className="h-4 w-4 text-gold" data-id="element-183" data-mp="ddwzl7up42h7" />
            100% PDF
          </span>
          <span className="flex items-center gap-1.5" data-id="element-184" data-mp="1azkutpff0er5">
            <ClockIcon aria-hidden="true" className="h-4 w-4 text-gold" data-id="element-185" data-mp="1622hznya1fdv" />
            Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-186" data-mp="1126m6bzqgu9e">
            <SparklesIcon aria-hidden="true" className="h-4 w-4 text-gold" data-id="element-187" data-mp="114svoh66pju9" />
            Todos los niveles
          </span>
          <span className="flex items-center gap-1.5" data-id="element-188" data-mp="3lsp1j88sy9bs">
            <AwardIcon aria-hidden="true" className="h-4 w-4 text-gold" data-id="element-189" data-mp="3lui8ypr8oxku" />4 aparatos
          </span>
        </div>
        <div className="mt-7" data-id="element-190" data-mp="3htg8y6pi0hht">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-191" data-mp="1x9kwssxc7gkd">
            🤸‍♀️ Quiero mi Combo Completo ahora →
          </Button>
        </div>
        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-medium text-zinc-500 md:text-sm" data-id="element-192" data-mp="218jzs7zid396">
          <span className="flex items-center gap-1" data-id="element-193" data-mp="2b198iv3oc30t">
            <ShieldCheckIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-194" data-mp="2b2smug5rs3zy" />
            Garantía 7 días
          </span>
          <span aria-hidden="true" className="text-zinc-700" data-id="element-195" data-mp="2kyna5okxun92">
            ·
          </span>
          <span className="flex items-center gap-1" data-id="element-196" data-mp="2p0h6xls0j73y">
            <LockIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-197" data-mp="2p1s8dexzk2rw" />
            Pago seguro
          </span>
          <span aria-hidden="true" className="text-zinc-700" data-id="element-198" data-mp="2tysgdveebfln">
            ·
          </span>
          <span className="flex items-center gap-1" data-id="element-199" data-mp="uoakfqto53wc">
            <CreditCardIcon aria-hidden="true" className="h-3.5 w-3.5 text-gold" data-id="element-200" data-mp="zl10ie5h3zhr" />
            Mercado Pago
          </span>
        </div>
        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-201" data-mp="49t4lwvct2tx">
          <TrustCard icon={<UsersIcon className="h-5 w-5 text-gold" data-id="element-203" data-mp="3vhfew8ckw3jr" />} text="+300 entrenadores confían" data-id="element-202" data-mp="3vgniivb5q1sf" />
          <TrustCard icon={<BookOpenIcon className="h-5 w-5 text-gold" data-id="element-205" data-mp="9ah313lwwly6" />} text="6 Tomos listos" data-id="element-204" data-mp="e7h8bcaxtko8" />
          <TrustCard icon={<GiftIcon className="h-5 w-5 text-gold" data-id="element-207" data-mp="3hqaaksy9mn33" />} text="6 Bonos incluidos" data-id="element-206" data-mp="98e2hpn4vaf7" />
          <TrustCard icon={<StarIcon className="h-5 w-5 fill-gold text-gold" data-id="element-209" data-mp="3crftpwjuz8lm" />} text="4,9/5 · ★★★★★" data-id="element-208" data-mp="3ho69sjvny471" />
        </div>
      </div>
    </section>;
}
function TrustCard({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex flex-col items-center gap-2 rounded-2xl border border-line bg-surface p-3" data-id="element-210" data-mp="3mollz847l5nf">
      <span aria-hidden="true" data-id="element-211" data-mp="2yy805zc7w31a">{icon}</span>
      <span className="text-center text-[11px] font-bold leading-tight text-white md:text-sm" data-id="element-212" data-mp="2u0po402wl7p2">
        {text}
      </span>
    </div>;
}